import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import ComboBox from 'Components/ComboBox'
import CustomButton from 'Components/CustomButton/CustomButton'

import { useState } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { makePostRequest } from 'utils/api'

export default function AddConnection({ updateList, openM = false }) {
  const [open, setOpen] = useState(openM)
  const [type, setType] = useState({})
  const navigate = useNavigate()
  const location = useLocation()
  let w_contact_import = localStorage.getItem('w-contact-import')
  const handleClickOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
    updateList()
  }

  const onSubmit = async (data) => {
    const payload = {
      type: type.label,
      categorie: type.categorie,
    }

    const response = await makePostRequest('/api/user/add-connectes/', payload, {}, true)
    if (response.status === 200) {
      localStorage.setItem('return_url', location.pathname)
      localStorage.setItem('opencc', true)
      window.location.replace(response.data.url)
      handleClose()
    }
  }
  const acc_types = [
    { id: 1, value: 'Google', label: 'Google', categorie: 'Google' },
    { id: 2, value: 'Microsoft', label: 'Microsoft', categorie: 'Microsoft' },
  ]
  return (
    <>
      <CustomButton onClick={handleClickOpen}>créer</CustomButton>
      <Dialog fullWidth maxWidth="xs" open={open} onClose={handleClose}>
        <DialogTitle sx={{ color: 'black !important' }}>Connecter un compte</DialogTitle>
        <form>
          <DialogContent>
            <ComboBox
              handleAutoComplete={(e, j) => {
                setType(j)
              }}
              label="Accounts"
              data={acc_types}
              name="type"
              required={true}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={onSubmit}>Valider</Button>
            <Button
              onClick={() => {
                handleClose()
                if (w_contact_import) {
                  localStorage.removeItem('w-contact-import')
                  navigate('/')
                }
              }}
            >
              Annuler
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  )
}
